import { useState } from 'react';

interface Props {
  startTime: string;
  endTime: string;
  timezone?: string;
  meetingLink: string;
}

export function BookingDetails({ startTime, endTime, meetingLink }: Props) {
  const [copied, setCopied] = useState(false);

  const formatDate = (iso: string) => {
    return new Date(iso).toLocaleString('es-ES', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  const formatTime = (iso: string) => {
    return new Date(iso).toLocaleString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const userTimezone = (() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return '';
    }
  })();

  const copyLink = () => {
    navigator.clipboard.writeText(meetingLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="hit-card mb-4">
      <h3 className="text-sm font-extrabold uppercase tracking-widest text-hit-gray-dark mb-4">
        📅 Fecha y Hora
      </h3>

      <p className="font-bold text-hit-black capitalize text-lg leading-snug">
        {formatDate(startTime)}
      </p>

      <p className="text-hit-gray-dark mt-1">
        {formatTime(startTime)} — {formatTime(endTime)}
        {userTimezone && (
          <span className="ml-2 text-xs text-hit-gray-mid">({userTimezone})</span>
        )}
      </p>

      {meetingLink && (
        <div className="mt-4 pt-4 border-t border-hit-gray-light">
          <p className="text-sm font-semibold text-hit-gray-dark mb-2">📍 Link de la reunión:</p>
          <div className="flex items-center gap-2 flex-wrap">
            <a
              href={meetingLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 underline break-all"
            >
              {meetingLink}
            </a>
            <button
              type="button"
              onClick={copyLink}
              className="text-xs font-semibold text-hit-gold border border-hit-gold/40 rounded px-2 py-1 hover:bg-hit-gold/10 transition-colors flex-shrink-0"
            >
              {copied ? '✓ Copiado' : 'Copiar'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
